import React from "react";
import { Form, Input } from "antd";

const TextAreaField = () => {
	return (
		<Form.Item label="Ответ">
			<Input value={"Текстовый ответ пользователя"} disabled />
		</Form.Item>
	);
};

export default TextAreaField;
